module.exports = __webpack_public_path__ + "static/media/logo_backend.0d63d38a.svg";